import { css } from "@emotion/css";
import { fontSize, space, themeTokens } from "@octopusdeploy/design-system-tokens";
import type React from "react";
interface LeftoversProps {
    count?: number | null;
    name: string;
    showAll?: boolean;
    onShowAllChanged?: () => void;
    style?: React.CSSProperties;
}
export function Leftovers(props: LeftoversProps) {
    function handleOnClick() {
        if (props.onShowAllChanged)
            props.onShowAllChanged();
    }
    if (props.showAll && props.onShowAllChanged) {
        return (<span className={styleExpandable} onClick={handleOnClick} style={props.style}>
                Show summary
            </span>);
    }
    if (!props.count)
        return <></>;
    return (<span style={props.style} className={props.onShowAllChanged ? styleExpandable : style} onClick={handleOnClick}>
            +{props.count} {props.name}
            {props.count > 1 && "s"}
        </span>);
}
const style = css({
    marginLeft: space[12],
    fontSize: fontSize.medium,
    color: themeTokens.color.text.tertiary,
    whiteSpace: "nowrap",
});
const styleExpandable = css({
    marginLeft: space[12],
    fontSize: fontSize.medium,
    color: themeTokens.color.text.link.default,
    cursor: "pointer",
    whiteSpace: "nowrap",
});
